import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me", { validateStatus: (s) => s === 200 || s === 401 })
      .then((r) => setUser(r.status === 200 ? r.data : false))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = (data) => {
    setUser(data.user);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed, clearing local session anyway", e); }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout, ready }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
